import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { CSVLink } from 'react-csv';
import Swal from 'sweetalert2';
import axios from "axios";
import { useUser } from '../context/UserContext';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const PlayerCoachlist = () => {
  const [playerCoachList, setPlayerCoachList] = useState([]);
  const [academy, setAcademy] = useState('');
  const { selectedCenter} = useUser();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState({
    start: new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0],
    end: new Date().toISOString().split('T')[0]
  });
  const [academyList, setAcademyList] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const token = localStorage.getItem('auth-token');
  useEffect(() => {
    const fetchAcademyData = async () => {
      setLoading(true);
      setError('');
      try {
        if (academyList.length === 0) {
          const academyResponse = await fetch(process.env.REACT_APP_API_URL_FEEDBACK_FETCH, {
            headers: {
              'Authorization': `Bearer ${token}`,
            },
          });
          const academyData = await academyResponse.json();
          if (academyData.success) {
            const options = Object.entries(academyData.data.academyNameMap).map(([id, name]) => ({
              value: parseInt(id),
              label: name,
            }));
            setAcademyList(options);
            if (!academy) {
              const defaultAcademy = options.find(opt => opt.value === Number(selectedCenter));
              if (defaultAcademy) {
                setAcademy(defaultAcademy.value);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching academy data", error);
        setError('Failed to load academy data.');
      }
    };

    fetchAcademyData();
  }, []);


  const fetchPlayerData = async () => {
    if (!academy) {
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_PLAYER_COACH_LIST}?academyIds=${academy}` + `&fromDate=${dateRange.start}` +
        `&toDate=${dateRange.end}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      const players = response.data?.data?.playerCoachListDtos || [];

      const formattedData = players.map((player, index) => ({
        id: index + 1,
        academyId: player.academyId,
        academyName: player.academyName,
        playerName: player.playerName,
        playerContact: player.mobileNumber
          ? player.mobileNumber.replace(/^(\+91\s*|91\s*)/, '')
          : "N/A",

        parentContact: player.parentMobileNumber
          ? player.parentMobileNumber.replace(/^(\+91\s*|91\s*)/, '')
          : "N/A",
        batch: player.batchName || "N/A",
        plan: player.plan || "N/A",
        totalNewEnrollments: player.totalNewEnrollments || 0,
        weeklyFrequency: player.weekdays
          ? player.weekdays.map(day => ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][day]).join(", ")
          : "N/A",
        createdAt: player.createdAt ? new Date(player.createdAt).toISOString().split("T")[0] : null,

        dueIds: player.paymentDueIds ? player.paymentDueIds.join(", ") : "N/A",
        sport: player.sportName || "N/A",
        proficiency: player.proficiency || "N/A",
        subLevel: player.subLevel || "N/A",
        coachName: player.coachName || "Not Assigned",
        coachContactNumber: player.coachMobileNumber
          ? player.coachMobileNumber.replace(/^(\+91\s*|91\s*)/, '')
          : "-",
      }));


      setPlayerCoachList(formattedData);
    } catch (error) {

      setError('Something went wrong while fetching data.');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPlayerData();
  }, [academy, dateRange]);

  const headers = [
    { label: "Academy Name", key: "academyName" },
    { label: "Player Name", key: "playerName" },
    { label: "Player Contact", key: "playerContact" },
    { label: "Parent Contact", key: "parentContact" },
    { label: "Sport", key: "sport" },
    { label: "Proficiency", key: "proficiency" },
    { label: "Sub-Level", key: "subLevel" },
    { label: "Coach Name", key: "coachName" },
    { label: "Coach Contact", key: "coachContactNumber" },
  ];
  const handleAcademyChange = (selectedOption) => {
    setAcademy(selectedOption?.value || '');
    setError('');
  };


  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      let aValue = a[key];
      let bValue = b[key];

      if (typeof aValue === "string") aValue = aValue.trim().toLowerCase();
      if (typeof bValue === "string") bValue = bValue.trim().toLowerCase();

      if (aValue < bValue) return direction === "ascending" ? -1 : 1;
      if (aValue > bValue) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };
  const [sport, setSport] = useState('');
  const [proficiency, setProficiency] = useState('');
  const [subLevel, setSubLevel] = useState('');
  const filteredData = playerCoachList.filter((entry) => {

    const isSearchMatch = searchTerm ? entry.playerName.toLowerCase().includes(searchTerm.toLowerCase()) : true;
    const isSportMatch = sport ? entry.sport === sport : true;
    const isProficiencyMatch = proficiency ? entry.proficiency === proficiency : true;
    const isSubLevelMatch = subLevel ? entry.subLevel === subLevel : true;

    const isDateInRange = entry.createdAt
      ? new Date(entry.createdAt) >= new Date(dateRange.start) &&
      new Date(entry.createdAt) <= new Date(dateRange.end)
      : true;

    return (
      isSearchMatch &&
      isSportMatch &&
      isProficiencyMatch &&
      isSubLevelMatch &&
      isDateInRange
    );
  });

  const currentRows = sortData(filteredData).slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const totalEntries = filteredData.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;


  const uniqueSports = Array.from(new Set(playerCoachList.map((item) => item.sport)))
    .map((sport) => ({ value: sport, label: sport }));

  const uniqueProficiencies = Array.from(new Set(playerCoachList.map((item) => item.proficiency)))
    .map((prof) => ({ value: prof, label: prof }));

  const uniqueSubLevels = Array.from(new Set(playerCoachList.map((item) => item.subLevel)))
    .map((sub) => ({ value: sub, label: sub }));

  return (
    <div className="enrollment-container">
      <div className="sales-filters-login">
        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${academy ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={academyList}
            value={academyList.find(option => option.value === academy)}
            onChange={handleAcademyChange}
            placeholder="Academy"
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {academy && <label htmlFor="academy">Academy</label>}
        </div>

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${sport ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={uniqueSports}
            value={uniqueSports.find(option => option.value === sport)}
            onChange={(selectedOption) => setSport(selectedOption?.value || '')}
            placeholder="Sport"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {sport && <label htmlFor="sport">Sport</label>}
        </div>

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${proficiency ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={uniqueProficiencies}
            value={uniqueProficiencies.find(option => option.value === proficiency)}
            onChange={(selectedOption) => setProficiency(selectedOption?.value || '')}
            placeholder="Proficiency"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {proficiency && <label htmlFor="proficiency">Proficiency</label>}
        </div>

        <div className="floating-select">
          <Select
            className={`sales-filter-court-booking ${subLevel ? "has-value" : ""}`}
            classNamePrefix="react-select"
            options={uniqueSubLevels}
            value={uniqueSubLevels.find(option => option.value === subLevel)}
            onChange={(selectedOption) => setSubLevel(selectedOption?.value || '')}
            placeholder="Level"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              placeholder: (provided) => ({
                ...provided,
                color: 'black',
              }),
              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            }}
          />
          {subLevel && <label htmlFor="subLevel">Sub-Level</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${dateRange.start ? "has-value" : ""}`}
            value={dateRange.start}
            onChange={(e) => setDateRange({ ...dateRange, start: e.target.value })}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {dateRange.start && <label htmlFor="startDate">Start Date</label>}
        </div>

        <div className="floating-select">
          <input
            type="date"
            className={`sales-filter-academy ${dateRange.end ? "has-value" : ""}`}
            value={dateRange.end}
            onChange={(e) => setDateRange({ ...dateRange, end: e.target.value })}
            onClick={(e) => e.target.showPicker()}
            max={new Date().toISOString().split('T')[0]}
          />
          {dateRange.end && <label htmlFor="endDate">End Date</label>}
        </div>
      </div>

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">🔍 Search</label>
        </div>

        <CSVLink
          data={filteredData}
          headers={headers}
          filename="PlayerCoachList.csv"
          className="btn btn-primary no-decoration"
        >
          <button className="csv_button" type="button" >
            <span
              className="button__text"

            >
              Export CSV
            </span>
            <span className="button__icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" className="svg">
                <path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path>
                <path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path>
                <path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path>
              </svg>
            </span>
          </button>
        </CSVLink>
      </div>

      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchPlayerData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredData.length === 0 && <div className="error-message">No data available</div>}


      <div className="tt-table-container">
        <table className="tt-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {currentRows.map((entry) => (
              <tr key={entry.id}>
                <td>{entry.academyName}</td>
                <td>{entry.playerName}</td>
                <td>{entry.playerContact}</td>
                <td>{entry.parentContact}</td>
                <td>{entry.sport}</td>
                <td>{entry.proficiency}</td>
                <td>{entry.subLevel}</td>
                <td>{entry.coachName}</td>
                <td>{entry.coachContactNumber}</td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PlayerCoachlist;
